import React, {Component} from 'react';
import {Route, Switch,Redirect} from 'react-router-dom';
import MainWrapper from './MainWrapper';
//import Layout from '../pages/_layout/Layout';

import LogIn from '../../pages/log_in/LogIn';

//import Register from '../pages/account/register/Register';
//import Reset from '../pages/account/reset_password/ResetPassword';


import ErrorPage from '../../pages/error/ErrorPage'
//import Contact from "../pages/contact_us/ContactUs";
import * as TextManager from "../../modules/languages/TextManager";

class Router extends Component {

    render() {

        let content;
        if (this.props.hasError){
            content = wrappedRoutesError;
        }

        return (
            <MainWrapper>
                <main>
                    <Switch>

                        {/*<Route path='/reset_password' component={Reset}/>
                        <Route path='/contact' component={Contact}/>
                        <Route path='/register' component={Register}/>*/}
                        <Route path='/' component={LogIn}/>
                    </Switch>
                </main>
            </MainWrapper>
        );
    }
}


const wrappedRoutesError = () => (
    <div>
        {/*<Layout/>*/}
        <div className='container__wrap'>

            <ErrorPage/>

        </div>
    </div>
);


export default Router;
